import { useContext } from "react";
import { DraggingContext } from '@xnav/web/src/contexts/draggingContext'
import { VerifyNameContext } from "@/contexts/verifySectionNameContext";
import { ProblemContext } from "@/contexts/problemContext";
import { AppContext } from "@/contexts/appContext";
import { MediaContext } from "@/contexts/mediaContext";
import { S3ClientContext, SelectedContentContext, SelectedSectionContext, SelectionReferenceContext, StayUnsyncedContext, DynamoClientContext, ReferenceMediaContext, DereferenceMediaContext, DeletedContentContext, DeletedSectionsContext, ContentStructureContext, EditorSyncContext, UploadJobsContext, ContentStoreContext, SetContentStoreContext, SectionStoreContext, StructureDirtyContext } from "@/contexts/contexts";

export const useDragging = () => useContext(DraggingContext)
export const useVerifyName = () => useContext(VerifyNameContext)
export const useProblem = () => useContext(ProblemContext)
export const useApp = () => useContext(AppContext)
export const useMedia = () => useContext(MediaContext)
export const useSection = () => useContext(SelectedSectionContext)
export const useStayUnsynced = () => useContext(StayUnsyncedContext)
export const useSelectionReference = () => useContext(SelectionReferenceContext)
export const useSelectedContent = () => useContext(SelectedContentContext)
export const useS3Client = () => useContext(S3ClientContext)
export const useDynamoClient = () => useContext(DynamoClientContext)
export const useReferenceMedia = () => useContext(ReferenceMediaContext)
export const useDereferenceMedia = () => useContext(DereferenceMediaContext)
export const useDeletedContent = () => useContext(DeletedContentContext)
export const useDeletedSections = () => useContext(DeletedSectionsContext)
export const useContentStructure = () => useContext(ContentStructureContext)

export const useEditorSync= () => useContext(EditorSyncContext) 
export const useUploadJobs = () => useContext(UploadJobsContext)
export const useContentStore = () => useContext(ContentStoreContext)
export const useSetContentStore = () => useContext(SetContentStoreContext)
export const useSectionStore = () => useContext(SectionStoreContext)
export const useStructureDirty = () => useContext(StructureDirtyContext)

